import { useMediaQuery } from '@mui/material'

export const useDetectDevice = () => {
  const isMobileWidth = useIsMobileWidth()

  if (typeof window === 'undefined') return { isMobileAgent: false, hasMobileEvents: false, isMobileWidth }
  const isMobileAgent = /iPhone|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator?.userAgent)
  const hasMobileEvents = 'ontouchstart' in window && 'maxTouchPoints' in navigator && navigator?.maxTouchPoints > 0

  return { isMobileAgent, hasMobileEvents, isMobileWidth }
}

export const useIsMobileWidth = () => {
  return useMediaQuery((theme) => theme.breakpoints.down('md'))
}
